<template>
    <div v-if="isLoading" class="detail-product-card">
      <div class="skeleton-img"></div>
      <div class="flex-column">
        <div class="skeleton-label skeleton-text"></div>
        <div class="skeleton-title skeleton-text"></div>
        <div class="skeleton-label skeleton-text"></div>
        <div class="skeleton-address skeleton-text"></div>
      </div>
    </div>
    <div v-else class="detail-product-card">
      <img :src="imageUrl" alt="sample-product-logo" class="img-mitra-logo" />
      <div class="flex-column">
        <span class="detail-product-label">Detail Mitra</span>
        <h2 class="detail-product-name">{{ profile.nama_organisasi_perusahaan || '-' }}</h2>
        <span class="detail-product-label">Alamat Mitra:</span>
        <h2 class="detail-product-address">{{ fullAddress }}</h2>
      </div>
    </div>
</template>
  
<script>
  export default {
    name: "CardMitraDetail",
    props: {
      data: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        isLoading: true,
        wilayah: {
          provinsi: "-",
          kota: "-",
          kecamatan: "-",
          kelurahan: "-",
        },
      };
    },
    computed: {
      profile() {
        // console.log("data data : ", this.data);
        return (this.data && this.data.mitra && this.data.mitra.mitra_profile) || {};
      },
      imageUrl() {
        return this.profile.logo_mitra
          ? `${this.profile.logo_mitra}`
          : "";
      },
      fullAddress() {
        const alamat = this.profile.alamat_mitra || "-";
        const w = this.wilayah;
        return `${alamat}, Kelurahan ${w.kelurahan}, Kecamatan ${w.kecamatan}, Kota ${w.kota}, Provinsi ${w.provinsi}`;
      },
    },
    watch: {
      data: {
        handler(newVal) {
          const profile =
            (newVal && newVal.mitra && newVal.mitra.mitra_profile) || {};
          const hasWilayah =
            profile.provinsi &&
            profile.kota &&
            profile.kecamatan &&
            profile.kelurahan;
            
          if (hasWilayah) {
            this.fetchNamaWilayah(profile);
          } else {
            this.isLoading = true;
            console.warn("Data wilayah mitra belum lengkap.");
          }
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      async fetchNamaWilayah(profile) {
        try {
          const [prov, kota, kec, kel] = await Promise.all([
            this.$getNamaWilayah("provinsi", profile.provinsi),
            this.$getNamaWilayah("kota", profile.kota),
            this.$getNamaWilayah("kecamatan", profile.kecamatan),
            this.$getNamaWilayah("kelurahan", profile.kelurahan),
          ]);
  
          this.wilayah = {
            provinsi: (prov && prov.name) || "-",
            kota: (kota && kota.name) || "-",
            kecamatan: (kec && kec.name) || "-",
            kelurahan: (kel && kel.name) || "-",
          };
          this.isLoading = false;
        } catch (error) {
          this.isLoading = true;
          console.error("Gagal mengambil nama wilayah:", error);
        }
      },
    },
  };
</script>

<style scoped>
.img-mitra-logo {
  width: 180px; 
  height: 180px; 
  object-fit: contain;
  border-radius: 8px;
  background-color: #f9f9f9; 
}
.detail-product-card {
  padding: 25px 30px;
  border: 1px solid #6c6d70;
  display: flex;
  gap: 30px;
  border-radius: 15px;
  width: 100%;
}

.detail-product-label {
  font-size: 16px;
  font-weight: 600;
  color: #6c6d70;
}

.detail-product-name {
  font-size: 38px;
  font-weight: 600;
  color: #13346c;
  text-transform: uppercase;
  letter-spacing: 0px;
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}

.detail-product-address {
  font-size: 20px;
  font-weight: 500;
  color: #13346c;
  letter-spacing: 0px;
  text-transform: none;
  max-width: 50%;
  margin: 0px;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.skeleton-img {
  width: 180px;
  height: 180px;
  background: #e0e0e0;
  border-radius: 8px;
  animation: pulse 1.5s infinite;
}
.skeleton-text {
  background: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
  margin-bottom: 12px;
}
.skeleton-label {
  width: 120px;
  height: 20px;
}
.skeleton-title {
  width: 300px;
  height: 38px;
}
.skeleton-address {
  width: 90%;
  height: 20px;
}
@keyframes pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}

/* Responsive */
@media (max-width: 1024px) {
  .flex-column {
    display: flex;
    flex-direction: column;
    width: 100% !important;
  }

  .detail-product-card {
    padding: 25px 30px;
    border: 1px solid #6c6d70;
    display: flex;
    gap: 30px;
    border-radius: 15px;
    width: 100% !important;
    margin: auto;
  }

  .detail-product-address {
    font-size: 20px;
    font-weight: 500;
    color: #13346c;
    letter-spacing: 0px;
    text-transform: none;
    max-width: 100% !important;
    margin: 0px;
  }
}

@media (max-width: 768px) {
  .detail-product-card {
    flex-direction: column;
  }

  .detail-product-label {
    font-size: 20px;
  }

  .detail-product-name {
    font-size: 24px !important;
  }

  .detail-product-address {
    font-size: 14px !important;
    max-width: 100% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/public/component-detail-deposito-tabungan/CardMitraDetail.vue